import moment from 'moment';

let setWatermark = str => {
  let id = 'watermark_box';

  if (document.getElementById(id) !== null) {
    document.body.removeChild(document.getElementById(id));
  }

  let can = document.createElement('canvas');
  // 设置canvas画布大小
  can.width = 360;
  can.height = 240;

  let cans = can.getContext('2d');
  cans.rotate((-45 * Math.PI) / 360); // 水印旋转角度
  cans.font = '18px 微软雅黑';
  cans.fillStyle = '#000';
  cans.textAlign = 'center';
  cans.textBaseline = 'middle';

  // 时间
  const nowTime = moment().format('YYYY-MM-DD HH:mm');

  // fillText("要现实的文字",x,y)，这里面的x,y代表的是哪个点的坐标
  cans.fillText(nowTime, can.width / 2, can.height - 27, can.width);
  cans.fillText(str, can.width / 2, can.height, can.width); // 水印在画布的位置x，y轴

  let div = document.createElement('div');
  div.id = id;
  //pointerEvents此CSS属性设置为“none”时，元素不接收悬停/单击事件，而事件将发生在其后面的任何内容上。
  div.style.pointerEvents = 'none';
  div.style.top = '50px';
  div.style.left = '40px';
  div.style.opacity = '0.1';
  div.style.position = 'fixed';
  div.style.zIndex = '1000000';
  div.style.width = document.documentElement.clientWidth + 'px';
  div.style.height = document.documentElement.clientHeight + 'px';
  div.style.background = 'url(' + can.toDataURL('image/png') + ') left top repeat';
  document.body.appendChild(div);
  return id;
};

// 添加水印方法
export const setWaterMark = str => {
  let id = setWatermark(str);
  if (document.getElementById(id) === null) {
    id = setWatermark(str1);
  }
};

// 移除水印方法
export const removeWatermark = () => {
  let id = 'watermark_box';
  if (document.getElementById(id) !== null) {
    document.body.removeChild(document.getElementById(id));
  }
};
